import React from 'react';
import Select from 'react-select';
import _ from 'lodash';
import Popover from 'react-popover';

class RuleSelector extends React.Component {
    constructor(props) {
        super(props);

        
        this.defaultState = this.defaultState.bind(this);
        this.showSelector = this.showSelector.bind(this);
        this.changeDropdown = this.changeDropdown.bind(this);
        this.changeOptionValue = this.changeOptionValue.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);


        this.defaultState(props);
        
    }

    defaultState(props) {
        this.state = {
            'isEditing':false
        };      
    }

    swapEdit(e) {
        this.setState({'isEditing':!this.state.isEditing});
    }

    changeOptionValue(e,value) {
        e.stopPropagation();
        this.swapEdit();
    }

    changeDropdown() {

    }

    getLabelFromValue() {
        if(typeof this.props.options === 'undefined') {
            return this.props.value;
        }else{
            return _.find(this.props.options, {'value':this.props.value}).value;
        }
        
    }

    handleTextChange() {
        this.swapEdit();
    }

    componentDidUpdate() {
        if(typeof this.props.options === 'undefined' && this.state.isEditing) {
            this.refs.valuetext.focus();
        }
    }

    showSelector() {

        if(this.state.isEditing == false) {
            return <span onClick={(e) => {e.stopPropagation();this.swapEdit(e);} } className="selected-rule">{this.getLabelFromValue()}</span>;
        }

        return (
            <div className="popover bottom">
                    <div className="arrow"></div>
                    <h3 className="popover-title">asd</h3>
                    <div className="close-btn"><i className="icon wb-close"></i></div>
                    <div className="popover-content">
                      <p>Sed posuere consectetur est at lobortis. Aenean eu leo quam.</p>
                    </div>
                  </div>
        )

        if(typeof this.props.options === 'undefined') {
            return <div className="form-group form-material">
                  <input type="text" ref="valuetext" className="form-control" onKeyDown={this.handleTextChange} value={this.props.value} / >
                </div>
            //return <input type="text"  className="form-control" onKeyDown={this.handleTextChange} value={this.props.value} />
        }

        return <div className="dropdown open">
                    <button type="button" className="btn btn-primary dropdown-toggle btn-sm" id="exampleActiveDropdown" aria-expanded="true" data-toggle="dropdown">
                      {this.getLabelFromValue()}
                      <span className="caret"></span>
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="exampleActiveDropdown" role="menu">
                        {this.props.options.map(o => {
                            if(o.value == this.props.value) {
                                return <li key={o.value} onClick={(e) => this.changeOptionValue(e,o.value)} className="active" role="presentation"><div>{o.label}</div></li>
                            }else{
                                return <li key={o.value} onClick={(e) => this.changeOptionValue(e,o.value)} role="presentation"><div>{o.label}</div></li>
                            }
                        })}
                     
                    </ul>
                  </div>
    }

    render() {
       
        return (
                <div className="list-group-item blue-grey-500">
                    
                    <i className="icon wb-arrow-right" aria-hidden="true"></i> {this.props.prepend}&nbsp;
                    {this.showSelector()}  
                    &nbsp;
                    {this.props.append}
                </div>
        );
    }

  
}

export default RuleSelector;




// WEBPACK FOOTER //
// ./components/builder/RuleSelector.js